export enum VipLevel {
	NONE = 0,
	SILVER = 1, // 白银会员
	LEVEL_1 = 2, // 黄金会员体验（白名单有效期内）
	LEVEL_2 = 3, // 黄金会员
}

export interface VipInfo {
	level: VipLevel;
	name: string;
	description: string;
	expiresAt?: Date;
	isActive: boolean;
}

export interface WhitelistUser {
	id: string;
	start_time: string;
	end_time: string;
	info: string;
}
